import React from 'react'
import './Value.css'
import {BiEditAlt} from 'react-icons/bi';
import { FaTrash } from 'react-icons/fa';
import { useDispatch, useSelector } from 'react-redux';
import { useState, useEffect } from 'react';
import { MdArrowForwardIos } from 'react-icons/md';
import { getAllValues } from '../../../../api/ValuesRequest';
import { updateValue, deleteValue } from '../../../../actions/ValueAction';

const Value = ({ data, location, id }) => {

  var userImage = '';
  const dispatch = useDispatch();
  const actionFeed = useSelector((store)=>store.actionFeedReducer.actionFeed.follow);
  const {user} = useSelector((state)=>state.authReducer.authData);
  const [isEditing, setIsEditing] = useState(false);
  const [editedValue, setEditedValue] = useState(data.value);
  const [editedExpound, setEditedExpound] = useState(data.expound);
  const [values, setValues] = useState([]);
  const [selectedValue, setSelectedValue] = useState(data.value); // Pre-select current value

  useEffect(() => {
    const fetchValues = async () => {
      const res = await getAllValues();
      setValues(res.data);
    };
    fetchValues();
  }, []);

  const handleUpdate = () => {
    const updatedData = { 
        pointId: data._id, 
        value: editedValue, 
        expound: editedExpound 
    };
    dispatch(updateValue(user._id, data._id, updatedData)); 
    setIsEditing(false);
    setEditedValue(updatedData.value);
    setEditedExpound(updatedData.expound);
};

const handleDelete = () => {
  const isConfirmed = window.confirm("Are you sure you want to delete this value?");
  if (isConfirmed) {
    dispatch(deleteValue(user._id, data._id));
  }
};

  const generateContent = () => {
    switch (location) {
      case "myCompass":
        if (data.group) {
          const group = actionFeed.filter((user)=>user._id==data.group);
          console.log("Group: ", group);
          userImage = group[0].userImage;
        }
        
        return (
          <div className="value-text">
            <span>{data.value}</span>
            {data.group && <span><img src={process.env.REACT_APP_PUBLIC_FOLDER + userImage} /></span>}
          </div>
        )
      
      case "setCompass":
        
        return (
          <div className="value-set-compass">
          {isEditing ? (
            <div className='value-edit-form'>
              <select
                id="sc_dropdown"
                name="value"
                className="sc-value-dropdown"
                value={selectedValue}
                onChange={(e) => {
                  setSelectedValue(e.target.value);
                  setEditedValue(e.target.value);
                }}
              >
                {/* <option value="" disabled hidden>Choose a value to add to your Compass.</option> */}
                {values.map((val) => (
                  <option 
                    key={val._id} 
                    value={val.value} 
                    disabled={val.valueType === 0}
                  >
                    {val.valueType === 0 ? `Core Value: ${val.value}` : val.value}
                  </option>
                ))}
              </select>
              <textarea
                value={editedExpound}
                className='editInfoInput'
                cols="30"
                rows="5" 
                onChange={(e) => setEditedExpound(e.target.value)}
              />
              <div className="button-container">
              <button className="valueButton updateButton" onClick={handleUpdate}>Update</button>
              <button className="valueButton cancelButton" onClick={() => setIsEditing(false)}>Cancel</button>
            </div>
            </div>
          ) : (
            <div className='value-text FlexRow'>
              <span><b>{data.value}</b></span>
              <span className='value-edit-icon' onClick={() => setIsEditing(true)}><BiEditAlt /></span>
              <span className='value-delete-icon' onClick={handleDelete}><FaTrash /></span>
            </div>
          )}
          {data.expound && <span className='value-expound'>{data.expound}</span>}
        </div>
        )
          
      case "compassTab":
        if (data.groupImage) {
          userImage = data.groupImage;
        } else if (data.group) {
          const group = actionFeed.filter((user)=>user._id==data.group);
          if (group.length > 0) {
            userImage = group[0].userImage;
          } 
        }
        
        return (
          <>
            <div className="value-text">
              <span><b>{data.value}</b></span>
              {data.group && <span><img src={process.env.REACT_APP_PUBLIC_FOLDER + userImage} /></span>}
              
            </div>
            {data.expound &&
              <div className="value-expound" id={"value_expound_" + id}>
                <span>{data.expound}</span>
              </div>
            }
          </>
        )        

      case "userDetail":
        if (data.groupImage) {
          userImage = data.groupImage;
        } else if (data.group) {
          const group = actionFeed.filter((user)=>user._id==data.group);
          // console.log('group---------------------------',data.group)
          if(group[0]){
            userImage = group[0].userImage; 
          } 

        }
        
        return (
          <>
            <div className="value-text" onClick={()=>handleExpandValue(id)}>
              <span><b>{data.value}</b></span>
              {data.group && <span><img src={process.env.REACT_APP_PUBLIC_FOLDER + userImage} /></span>}
              {data.expound && <MdArrowForwardIos id={"value_expand_2" + id} className='General-exp-arrow General-exp-arrow-con' />}
            </div>
            {data.expound &&
              <div className="value-expound2" id={"value_expound_2" + id}>
                <span>{data.expound}</span>
              </div>
            }
          </>
        )        
    }
  }

  const handleExpandValue = (i) => {
    document.getElementById("value_expand_2" + i).classList.toggle("General-exp-arrow-con");
    const expoundElement = document.getElementById("value_expound_2" + i);

    if (expoundElement.classList.contains("expanded")) {
        expoundElement.style.maxHeight = expoundElement.scrollHeight + "px";
        setTimeout(() => {
            expoundElement.style.maxHeight = "0px";
        }, 10);
        expoundElement.style.opacity = "0";
        expoundElement.classList.remove("expanded");
    } else {
        expoundElement.style.display = "block";
        expoundElement.style.maxHeight = expoundElement.scrollHeight + "px";
        expoundElement.style.opacity = "1";
        expoundElement.classList.add("expanded");
    }
  }

  return (
    <div className='Value'>  
      {/* wait for server response here */}
      {generateContent()}
    </div>
  );
}

export default Value